import { useCallback } from "react";
import { useDispatch, useStore } from "react-redux";
import { isClubImportNudgeEligible, promptClubImportNudge, } from "./clubImportNudge";
/**
 * Point-of-action nudge, the same shape as useCreditGate: call it right after
 * the action the import would improve, and it raises the dialog when the user
 * is eligible.
 *
 * ```ts
 * const nudge = useClubImportNudge("sbc-solver");
 * dispatch(solveSbc(id));
 * nudge({ subsection: "Set View" });
 * ```
 *
 * Read at call time rather than subscribed: nothing on screen should re-render
 * because a nudge *could* show.
 */
export const useClubImportNudge = (nudgeId) => {
    const dispatch = useDispatch();
    const store = useStore();
    return useCallback(({ subsection } = {}) => {
        if (!isClubImportNudgeEligible(store.getState()))
            return false;
        dispatch(promptClubImportNudge(nudgeId, subsection));
        return true;
    }, [dispatch, store, nudgeId]);
};
//# sourceMappingURL=useClubImportNudge.js.map